// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ToolOutlinedSvg from "@fishx/icons-svg/es/asn/ToolOutlined";
import FishxIcon from '../components/FishxIcon';

var ToolOutlined = function ToolOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ToolOutlinedSvg
  }));
};

ToolOutlined.displayName = 'ToolOutlined';
export default React.forwardRef(ToolOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ToolOutlined.js
// module id = 4265
// module chunks = 0